import React from 'react';

import { Box, Button, Col, Row, Typography } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import { AdjustPayment } from './AdjustPayment/index';
import { handleActivePanelChange as handleActivePanelChangeCommon, handleClickGoToPanelById } from './BillingServicesPaymentManagement.api';
import { ManageCurrentPayment } from './ManageCurrentPayment';
import { BillingServicesReportsPaymentBalance } from './PaymentBalance/index';
import { PaymentHistory } from './PaymentHistory';
import { PostPayment } from './PostPayment/index';
import { ReportInsufficientFunds } from './ReportInsufficientFunds/index';

const BillingServicesPaymentManagement = () => {
  const [activePanel, setActivePanel] = React.useState('0');

  const paymentManagementActive = activePanel === '0';
  const adjustPaymentActive = activePanel === '1';
  const postPaymentActive = activePanel === '2';
  const reportInsufficientFundsActive = activePanel === '3';
  const reportPaymentBalanceActive = activePanel === '4';
  const reportPaymentHistoryActive = activePanel === '5';
  const manageCurrentPayment = activePanel === '6';

  const resetFlow = () => {
    setActivePanel('0'); // define state var that is fn to use as a prop in children
  };

  const handleClickGoToAdjustPayment = () => handleClickGoToPanelById(setActivePanel, 1);

  const handleClickGoToPostPayment = () => handleClickGoToPanelById(setActivePanel, 2);

  const handleClickGoToNSFPayment = () => handleClickGoToPanelById(setActivePanel, 3);

  const handleActivePanelChange = (e) => handleActivePanelChangeCommon(e, setActivePanel);

  return (
    <>
      {paymentManagementActive && (
        <>
          <Box id={'billing-payment-management-title'} mb={2}>
            <Typography variant={'h6'}>Payment Management</Typography>
          </Box>
          <Row mb={2} spacing={2}>
            <Feature allowed={'Access_PaymentManagement_External'}>
              <Col>
                <Button variant="outlined" data-panelid={1} onClick={handleActivePanelChange}>
                  Adjust Payment
                </Button>
              </Col>
            </Feature>
            <Feature allowed={'Access_PaymentManagement_External'}>
              <Col>
                <Button variant="outlined" data-panelid={2} onClick={handleActivePanelChange}>
                  Post Payment
                </Button>
              </Col>
            </Feature>
            <Feature allowed={'Access_PaymentManagement_External'}>
              <Col>
                <Button variant="outlined" data-panelid={3} onClick={handleActivePanelChange}>
                  Report Insufficient Funds
                </Button>
              </Col>
            </Feature>
            <Feature allowed={'Access_PaymentBalance_Report'}>
              <Col>
                <Button variant="outlined" data-panelid={4} onClick={handleActivePanelChange}>
                  Payment Balance
                </Button>
              </Col>
            </Feature>
            <Feature allowed={'Access_PaymentHistory_And_Current_Payments'}>
              <Col>
                <Button variant="outlined" data-panelid={5} onClick={handleActivePanelChange}>
                  Payment History
                </Button>
              </Col>
            </Feature>
            <Feature allowed={'Access_PaymentHistory_And_Current_Payments'}>
              <Col>
                <Button variant="outlined" data-panelid={6} onClick={handleActivePanelChange}>
                  Manage Current Payments
                </Button>
              </Col>
            </Feature>
          </Row>
        </>
      )}

      {adjustPaymentActive && <AdjustPayment resetFlow={resetFlow} />}

      {postPaymentActive && <PostPayment resetFlow={resetFlow} />}

      {reportInsufficientFundsActive && <ReportInsufficientFunds resetFlow={resetFlow} />}

      <Feature allowed={'Access_PaymentManagement'}>
        {reportPaymentBalanceActive && (
          <BillingServicesReportsPaymentBalance
            resetFlow={resetFlow}
            handleClickGoToAdjustPayment={handleClickGoToAdjustPayment}
            handleClickGoToPostPayment={handleClickGoToPostPayment}
            handleClickGoToNSFPayment={handleClickGoToNSFPayment}
          />
        )}
      </Feature>

      <Feature allowed={'Access_PaymentHistory_And_Current_Payments'}>
        {reportPaymentHistoryActive && (
          <PaymentHistory
            resetFlow={resetFlow}
            handleClickGoToAdjustPayment={handleClickGoToAdjustPayment}
            handleClickGoToPostPayment={handleClickGoToPostPayment}
            handleClickGoToNSFPayment={handleClickGoToNSFPayment}
          />
        )}
      </Feature>

      <Feature allowed={'Access_PaymentHistory_And_Current_Payments'}>
        {manageCurrentPayment && (
          <ManageCurrentPayment
            resetFlow={resetFlow}
            handleClickGoToAdjustPayment={handleClickGoToAdjustPayment}
            handleClickGoToPostPayment={handleClickGoToPostPayment}
            handleClickGoToNSFPayment={handleClickGoToNSFPayment}
          />
        )}
      </Feature>
    </>
  );
};

export default BillingServicesPaymentManagement;
